import { Label } from "@admin/components/atoms/Input/Label";
import { MultiStateCheckbox } from "@admin/components/atoms/MultiStateCheckbox";

interface ControlsOptionsProps {
  controlsState: Record<string, { title: string; value: number }>;
  setControlsState: (
    state: Record<string, { title: string; value: number }>,
  ) => void;
}

export function ControlsOptions({
  controlsState,
  setControlsState,
}: ControlsOptionsProps) {
  const handleCheckboxChange = (type: string, value: number) => {
    setControlsState({
      ...controlsState,
      [type]: {
        ...controlsState[type],
        value,
      },
    });
  };

  return (
    <div style={{ flexDirection: "column", gap: 12, width: "100%" }}>
      {Object.entries(controlsState).map(([type, control]) => (
        <div
          key={type}
          className="flex flex-row w-full justify-between flex-wrap gap-4"
        >
          <Label title={control.title} itemsAlignment="justify-between">
            <div className="flex gap-2.5">
              {[1, 2, 3].map((checkboxValue) => (
                <MultiStateCheckbox
                  key={`${type}-${checkboxValue}`}
                  value={control.value === checkboxValue ? checkboxValue : null}
                  onChange={(value) =>
                    handleCheckboxChange(type, checkboxValue)
                  }
                  states={[
                    {
                      icon:
                        checkboxValue === 1 ? (
                          <i className="ki-filled ki-check text-white"></i>
                        ) : checkboxValue === 2 ? (
                          <i className="ki-filled ki-minus text-white"></i>
                        ) : (
                          <i className="ki-filled ki-cross text-white"></i>
                        ),
                      value: checkboxValue,
                      className: `border-[1px] ${checkboxValue === 1 ? "bg-brand border-brand" : checkboxValue === 2 ? "bg-warning border-warning" : checkboxValue === 3 ? "bg-[#8D4F61] border-[#8D4F61]" : "bg-white "}`,
                    },
                  ]}
                />
              ))}
            </div>
          </Label>
        </div>
      ))}
    </div>
  );
}
